import i18n from "../../i18n";
import axios from "axios";

class SettingsService {



    // constructor() {
    //     // Default language
    //     let language = i18n.language;
    //
    //     i18n.on('languageChanged', () => {
    //         console.log("SettingsService language changed. Get data in " + i18n.language);
    //     });
    //
    //
    //
    // }

    // Method to detect user's preferred language
    static async detectLanguage(params) {
        if (params.language) {
            console.log("SettingsService Using language from URL params:", params.language);
            // Perform logic to set the selected language (e.g., update state, fetch translations, etc.)
            // For example, you can use react-i18next's changeLanguage method
            this.language = params.language;
        } else {
            if (!this.language) {
                const browserLanguage = navigator.language.split("-")[0];
                console.log("SettingsService Using browser language:", browserLanguage);
                // Perform logic to set the selected language based on browserLanguage
                // For example, you can use react-i18next's changeLanguage method
                this.language = browserLanguage;
            } else {
                console.log("The language is already defined. Skip overwriting the language by browser language.");
            }
        }

        if (this.language !== i18n.language) {
            console.log("SettingsService update language");
            await i18n.changeLanguage(this.language)
        }
    }


    static async fetchTourSettings(i18n, params, activeTour) {
     //   const languageLoaded = useContext(LanguageContext);
      //  const selectedLanguage = languageLoaded.state.selected;
     //   const navigate = useNavigate();

      //  const params = useParams();
      //  const tourSettings = useContext(SettingsContext);

        try {

            let headers = {

                ...(activeTour && {
                    "X-Tour-Id": activeTour
                }),
            }

            console.log(headers);

            const response = await axios.get(process.env.CLIENT_API_URL + '/client/settings', {headers: headers});

                console.log(Array.isArray(response.data));

                // Simulate a delay of 1000 milliseconds (1 second)
                //await new Promise(resolve => setTimeout(resolve, 1000));

                // if the current language is not in the list of languages of the tour, switch to the first language of that tour
                if (!params.language) {
                    console.log("check if the browser language is available in the tour");
                    console.log(response.data?.languages, this.language);

                    if (response.data?.languages) {
                        const res = response.data?.languages?.find(language => language.code === this.language);
                        //const res = response.data.languages.includes({code: this.language});
                        if (!res) {
                            // switch everything to the first language of the tour
                            this.language = response.data.languages[0].code;
                            console.log("SettingsService update language from the tour: ", this.language);
                            await i18n.changeLanguage(this.language)
                        } else {
                            console.log("The browser language is supported by the tour. No switching required.");
                        }

                        console.log("result", res);
                    } else {
                        console.log("No languages configured (can happen when there are no languages in the account or tour)");
                    }

                } else {
                    console.log("Ignore checking tour languages. Forcing params language.");
                }



                console.log(response.data);
                return response.data;



        } catch (error) {
            throw error;
            // if (error.response && error.response.status === 404) {
            //     navigate(`/${params.language ? `${params.language}/` : ''}not-found`);
            // } else {
            //     console.log(error.response.data);
            // }
        }
    }

}

export default SettingsService;